import { NoWarningComponent } from './no-warning.component';

import { LanguageService } from '../shared/services/language.service';
import { WarningService, WarnRegion } from './warning.service';

import { DatexPipe } from '../shared/datex.pipe';

import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Router, RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

export const MODULES = [
  CommonModule,
  MatCardModule,
  RouterModule,
  TranslateModule,
];
export const COMPONENTS = [FaIconComponent, NoWarningComponent];
export const PIPES = [DatexPipe];

@Component({
  selector: 'app-warning-current',
  templateUrl: './warning-current.component.html',
  styleUrls: ['./warning.component.scss'],
  imports: [...MODULES, ...COMPONENTS, ...PIPES],
})
export class WarningCurrentComponent {
  public warningService = inject(WarningService);
  private router = inject(Router);
  public languageService = inject(LanguageService);

  onShowWarningsForRegion(region: WarnRegion): void {
    this.warningService.selectedRegion.set({ ...region });
    this.router.navigate([
      '/warning',
      'timeline',
      region.season + '_' + region.id,
    ]);
  }
}
